import FindByIdRequest from '../entities/FindByIdRequest'
import FindByIdResponse from '../entities/FindByIdResponse'
import { ILoteRepository } from '../repositories/ILoteRepository'

export interface IFindById {
  execute(params: FindByIdRequest): Promise<FindByIdResponse>
}

export default class FindByIdImpl implements IFindById {
  constructor(private readonly lotesRepository: ILoteRepository) {}

  public async execute(params: FindByIdRequest): Promise<FindByIdResponse> {
    const response = await this.lotesRepository.findById(params)
    return response
  }
}
